
const state = {
  video: {
    duration: null,
    url: null,
    type: null,
    fast_url: null
  },
  current_time: null,
}

const mutations = {
  setVideo(state, video){
    state.video = {
      duration: video.duration,
      url: video.url,
      type: video.type,
      fast_url: video.fast_url
    }
  },
  setCurrentTime(state, time) {
    state.current_time = time
  }
}

const actions = {

}

const getters = {
  getData: (state) => {
    return {
      duration: state.video.duration,
      url: state.video.url,
      type: state.video.type,
      fast_url: state.video.fast_url
    }
  },
  getCurrentTime: state => state.current_time,
  getVideoUrl: state => state.video.fast_url || state.video.url,
  getVideo: state => state.video,
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
